export default [
    "B.Sc",
    "B.Tech",
    "Honours",
    "Masters",
    "PhD"
]